import React, { Component, useState } from "react";
import { Grid, Button } from "@mui/material";
import { fonts } from "../../themes/themes";

interface handleClick {
  onClickSubmit: any;
  width?: string;
  height?: string;
  color?: string;
  backgroundColor?: string;
  borderRadius?: string;
  buttonText: any;
}
const CustomButton: React.FC<handleClick> = ({
  onClickSubmit,
  backgroundColor,
  borderRadius,
  color,
  height,
  width,
  buttonText,
}) => {
  return (
    <Grid item xs={12}>
      <Button
        style={{
          width: width,
          height: height,
          color: color,
          boxShadow: "0px 2px 2px #00000061",
          backgroundColor: backgroundColor,
          borderRadius: borderRadius,
          fontFamily: fonts.fontFamily,
          textTransform: "capitalize",
        }}
        onClick={onClickSubmit}
      >
        {buttonText}
      </Button>
    </Grid>
  );
};

export default CustomButton;
